import React from 'react';
import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import Row from 'components/Row';
import Text from 'components/Text';
import TextWithIcon from 'components/TextWithIcon';

import { CoachingReservation } from 'coaching/containers/GetAvailableReservationsContainer';

type Props = {
  selectedSubject?: string;
  studentName?: string;
  reservation: CoachingReservation;
  userTimezone: string;
  hideSessionFrequency?: boolean;
};

export default function TutoringSelfServeViewBilingSessionDetails({
  selectedSubject,
  studentName,
  reservation,
  userTimezone,
  hideSessionFrequency,
}: Props) {
  const durationMinutes = reservation.endDateTime.diff(reservation.startDateTime, 'minutes');
  return (
    <Row size="small">
      <Box color="eraser" textAlign="left" noShadow>
        <BoxBody size="xsmall">
          <Row size="xxsmall">
            <Text data-test="billing-session-details-header" size="small" weight="semibold">
              {`${selectedSubject} for ${studentName}`}
            </Text>
          </Row>
          {!hideSessionFrequency && (
            <Row size="xxsmall">
              <Text data-test="billing-session-details-pricing" size="small">
                One {durationMinutes}-minute session per week
              </Text>
            </Row>
          )}
        </BoxBody>
        <BoxBody light size="xsmall" rounded>
          <Row size="xxsmall">
            <Text size="small" color="graphite">
              Free first session
            </Text>
          </Row>
          <Row size="xxsmall">
            <TextWithIcon data-test="billing-session-details-start-time" icon="clock" size="small">
              {reservation.startDateTime.tz(userTimezone).format('ddd, MMM D [at] LT (z)')} •{' '}
              {durationMinutes} min
            </TextWithIcon>
          </Row>
        </BoxBody>
      </Box>
    </Row>
  );
}
